import { motion } from 'framer-motion';
import { MessageCircle, X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ChatButtonProps {
    onClick: () => void;
    isOpen: boolean;
    hasUnread: boolean;
}

const ChatButton = ({ onClick, isOpen, hasUnread }: ChatButtonProps) => {
    return (
        <motion.button
            onClick={onClick}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className={cn(
                "fixed bottom-6 left-6 z-50 w-14 h-14 rounded-full",
                "bg-gradient-to-br from-primary to-secondary",
                "flex items-center justify-center",
                "shadow-xl shadow-primary/30",
                "border border-white/20",
                "transition-all duration-300",
                "hover:shadow-2xl hover:shadow-primary/40",
                isOpen && "rotate-0"
            )}
        >
            {/* Pulse Animation */}
            {!isOpen && (
                <>
                    <span className="absolute inset-0 rounded-full bg-primary/50 animate-ping opacity-30" />
                    <span className="absolute inset-0 rounded-full bg-gradient-to-br from-primary/20 to-secondary/20 animate-pulse" />
                </>
            )}

            {/* Icon */}
            <motion.div
                animate={{ rotate: isOpen ? 90 : 0 }}
                transition={{ duration: 0.2 }}
            >
                {isOpen ? (
                    <X className="w-6 h-6 text-white" />
                ) : (
                    <MessageCircle className="w-6 h-6 text-white" />
                )}
            </motion.div>

            {/* Unread Indicator */}
            {hasUnread && !isOpen && (
                <span className="absolute -top-1 -right-1 w-4 h-4 bg-destructive rounded-full flex items-center justify-center">
                    <span className="w-2 h-2 bg-white rounded-full" />
                </span>
            )}
        </motion.button>
    );
};

export default ChatButton;
